/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 16:24 2022-05-03
 */

 import EnumItem, {enumMixn} from "./enumItem";

 let EnumUppercomputerType = {
     串口升级工具: 						new EnumItem('串口升级工具', 1,'串口升级工具'),
     通用测试工装: 					new EnumItem('通用测试工装', 2,'通用测试工装'),
     设备模拟器: 			new EnumItem('设备模拟器', 3,'设备模拟器'),
     ...enumMixn
 }
 export default EnumUppercomputerType